import "./titulo.scss";

export default function Titulo() {
  return (
    <section id="titulo" className="section titulo-page">
      <div className="container section-title fade-up text-center mb-5">
        <h2>Incorporación de Título</h2>
        <p>
          Trámite para el registro de títulos adicionales en la matrícula
          profesional del Colegio de Fonoaudiólogos de La Pampa.
        </p>
      </div>

      <div className="container fade-up">
        <div className="titulo-card">
          <div className="titulo-card-body">
            <p className="description">
              Para el trámite de incorporación de Título es necesario completar
              la nota de Solicitud de Incorporación de Título y abonar el
              arancel equivalente a dos códigos <strong>25.01.04</strong>.
            </p>

            <div className="steps">
              <div className="step">
                <div className="step-num">1</div>
                <div className="step-text">
                  Descargar y completar la{" "}
                  <strong>Nota de Solicitud de Incorporación de Título</strong>
                </div>
              </div>
              <div className="step">
                <div className="step-num">2</div>
                <div className="step-text">
                  Abonar el arancel equivalente a{" "}
                  <strong>dos (2) códigos 25.01.04</strong>
                </div>
              </div>
              <div className="step">
                <div className="step-num">3</div>
                <div className="step-text">
                  Presentar la solicitud completa con el comprobante de pago en
                  la sede del Colegio
                </div>
              </div>
            </div>

            <div className="info-box">
              <i className="bi bi-info-circle-fill"></i>
              <span>
                Ante cualquier consulta comunicarse con la sede del Colegio al{" "}
                <strong>02954-702284</strong> o por email a{" "}
                <strong>cofolp@gmail.com</strong>
              </span>
            </div>

            <div className="download-actions">
              <a
                href="/assets/portal/docs/SOLICITUD_DE_INCORPORACION_DE_TITULO.pdf"
                className="btn-download primary"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-download"></i>
                Descargar Solicitud Incorporación de Título
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
